import React, { useEffect, useState } from "react";
import GenericTabs from "../../genericComponents/GenericTabs";
import SpotOpportunities from "./SpotOpportunities";
import WinOpportunities from "./winOpportunities";
import IncreaseDealSize from "./increaseDealSize";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
// Removed logging imports (getUrlDetailsObj, getUserStatsObject, recordActivity)
// import { getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../../services/commonService";


function MaximisePipeComp() {
  const [spotOpportunities,setSpotOpportunities]= useState([]);
  const [, setSearchParams] = useSearchParams();
  const { clientName, accountId, accountName } = useParams();

  const [searchParams] = useSearchParams();

  // var currentUrl = useLocation().pathname; // Not needed
  // const pageParsedData = getUrlDetailsObj(useLocation, useParams); // Not needed

  // **Original Logic Restored:** Sets the default subtab on initial load.
  useEffect(() => {
    // This is the code that ensures 'spot_opportunitites' is the default subTab.

    setSearchParams({
      tab: "maximise_pipe",
      subTab: "spot_opportunitites",
    });
  }, []); // Runs only on mount

  // **CRITICAL FIX: Logging block REMOVED. This was the source of duplicate/triple calls.**
  /*
  useEffect(() => {
    const allParams = Object.fromEntries(searchParams.entries());
    if (allParams.tab !== "maximise_pipe") return; 
    // ... recordActivity call was here
  }, [searchParams])
  */

  const tabData = [
    { tabId:"spot_opportunitites",label: "Spot Opportunities", comp: <SpotOpportunities setSpotOpportunities={setSpotOpportunities}/> },
    { tabId:"win_opportunitites",label: "Win Opportunities", comp: <WinOpportunities spotOpportunities={spotOpportunities}/> },
    {tabId:"increase_deal_size", label: "Increase Deal Size", comp:  <IncreaseDealSize spotOpportunities={spotOpportunities}/>}
  ];

  return (
  
      <GenericTabs tabs={tabData} />

  );
}

export default MaximisePipeComp;
